import Axios from 'axios';

export function getPages(params) {
  return Axios.create({
    url: '/page'
  }).request({
    params
  })
}

export function getArticle(params) {
  return Axios.create({
    url: '/article'
  }).request({
    params
  })
}

export function getExperts(params = {}) {
  return Axios.create({
    url: '/article'
  }).request({
    params: {
      categories_id: '[6]',
      ...params
    }
  })
}

export function getRecruitments() {
  return Axios.create({
    url: '/article'
  }).request({
    params: {
      categories_id: '[24]',
      pagesize:10000
    }
  })
}

export function createConsultation(data) {
  return Axios.create({
    url: '/consultation',
    method: 'post'
  }).request({
    data
  })
}
